import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionSweepQuoteReceiptRangeFragment } from "./CollectionSweepQuoteReceiptRange.fragment"
import { getCollectionSweepQuoteErrorFragment } from "./getCollectionSweepQuoteError.fragment"

export const CollectionSweepQuoteReceiptFragment = graphql(
  `
    fragment CollectionSweepQuoteReceipt on CollectionSweepQuoteResponse {
      collection {
        name
        imageUrl
        ...CollectionLockup
      }

      ...CollectionSweepQuoteReceiptRange

      quote {
        __typename
        ...getCollectionSweepQuoteError
      }
    }
  `,
  [
    CollectionLockupFragment,
    CollectionSweepQuoteReceiptRangeFragment,
    getCollectionSweepQuoteErrorFragment,
  ],
)
